import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import { footerLinks } from "../../../utils/constants/footer-links";

const Footer = () => {
  return (
    <footer className="surface-ground relative overflow-hidden pt-8 pb-4">
      {/* Decorative Top Border */}
      <div
        className="absolute top-0 left-0 w-full h-1rem"
        style={{
          background: "linear-gradient(90deg, var(--primary-color), #FFD700)",
        }}
      ></div>

      <div className="container px-4 md:px-8">
        <div className="grid grid-nogutter justify-content-between mb-8">
          {/* Brand Section - Left */}
          <div className="col-12 md:col-4 mb-6 md:mb-0 text-center md:text-left">
            <Link
              to="/"
              className="no-underline inline-flex align-items-center gap-2 mb-4 justify-content-center md:justify-content-start"
            >
              <span className="inline-flex align-items-center justify-content-center bg-primary text-primary-inverse border-circle w-3rem h-3rem">
                <i className="pi pi-bolt text-xl" />
              </span>
              <span className="text-3xl font-black text-color">
                Doing<span className="footer-gradient-text">Sports</span>
              </span>
            </Link>
            <p className="text-color-secondary line-height-3 mt-0 mb-4 max-w-20rem mx-auto md:mx-0">
              Potenciando el deporte y conectando instituciones con atletas
              apasionados.
            </p>
            <div className="flex gap-3 justify-content-center md:justify-content-start">
              <a
                href="https://www.instagram.com/doingsports.ar"
                target="_blank"
                rel="noreferrer"
                className="social-icon-btn"
              >
                <Button
                  icon="pi pi-instagram"
                  rounded
                  text
                  severity="danger"
                  aria-label="Instagram"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/doing-sports"
                target="_blank"
                rel="noreferrer"
                className="social-icon-btn"
              >
                <Button
                  icon="pi pi-linkedin"
                  rounded
                  text
                  severity="info"
                  aria-label="LinkedIn"
                />
              </a>
              <a
                href={`https://wa.me/${process.env.REACT_APP_CONTACT_PHONE}`}
                target="_blank"
                rel="noreferrer"
                className="social-icon-btn"
              >
                <Button
                  icon="pi pi-whatsapp"
                  rounded
                  text
                  severity="success"
                  aria-label="WhatsApp"
                />
              </a>
            </div>
          </div>

          {/* Links Section - Center */}
          <div className="col-12 md:col-4 mb-6 md:mb-0 flex flex-column align-items-center text-center">
            <div className="text-left">
              <h3 className="text-xl font-bold text-color mb-4 text-center md:text-left">
                Explorar
              </h3>
              <div className="flex flex-column gap-3">
                {footerLinks.map((item) => (
                  <Link
                    key={item.title}
                    to={item.link}
                    className="footer-link text-color-secondary no-underline transition-all transition-duration-200 block text-center md:text-left"
                  >
                    {item.title}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {/* Contact Section - Right */}
          <div className="col-12 md:col-4 text-center md:text-right">
            <h3 className="text-xl font-bold text-color mb-4">Contacto</h3>
            <div className="flex flex-column gap-3 align-items-center md:align-items-end text-color-secondary">
              <span className="flex align-items-center gap-2">
                <i className="pi pi-envelope text-primary"></i>
                contacto@doing-sports.com
              </span>
              <span className="flex align-items-center gap-2">
                <i className="pi pi-map-marker text-primary"></i>
                Argentina
              </span>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-1px surface-border mb-4"></div>

        {/* Copyright */}
        <div className="text-center text-color-secondary text-sm">
          <p className="m-0">
            © 2025 <span className="font-bold text-primary">DoingSports</span>.
            Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
